import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FiPlus, FiSearch, FiLock } from 'react-icons/fi';
import { FormGroup, FormControl } from 'react-bootstrap';
import Loading from 'components/Loading';
import Layout from 'components/Layout';
import RuleList from 'components/Rules';
import RuleEditModal from 'components/Rules/RuleEditModal';
import { showModal, hideModal } from 'actions/modalActions';
import * as rulesActions from 'actions/rulesActions';
import * as timesActions from 'actions/timesActions';
import * as shiftsActions from 'actions/shiftsActions';
import Modal from 'components/Modal';
import HelpBanner from 'components/HelpBanner';
import UpgradeModal from 'components/Modal/UpgradeModal';
import { hasSubscriptionFeature } from 'utils/utils';
import { withTranslation } from 'react-i18next';

class Rules extends Component {
	constructor(props) {
		super(props);

		this.state = {
			searchRule: '',
			showUpgradeModal: false,
			upgradeFeature: '',
		};

		// console.log(props);
		this.closeModal = this.closeModal.bind(this);
		this.openNewRuleModal = this.openNewRuleModal.bind(this);
	}

	componentDidMount() {
		this.getRules();
		this.props.getSelectableAccounts();
		this.props.getSelectableTimeTypes();
		this.props.getSelectableShifts();
		this.props.getRuleTypes();
		this.props.getAccountTypes();
		this.props.getContracts();
	}

	handleChangeSearch = (event) => {
		this.setState(
			{
				[event.target.id]: event.target.value,
			},
			() => {
				this.getRules();
			}
		);
	};

	async getRules() {
		await this.props.getAllRules(this.state.searchRule);
	}

	closeModal() {
		this.props.hideModal();
	}

	openNewRuleModal() {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('rules.newRule'),
				style: { width: '670px' },
				content: <RuleEditModal handleClose={this.closeModal} />,
				closeModal: this.closeModal,
			},
			'edit'
		);
	}

	getContent = () => {
		if (this.props.loading) {
			return <Loading />;
		}

		if (!this.props.rules) {
			return this.props.t('rules.errorLoading');
		}

		return <RuleList rules={this.props.rules} />;
	};

	render() {
		return (
			<>
				<Layout configSidebar={true} className="page-rules" context="rules">
					<div className="heading">
						<h1 className="title">{this.props.t('rules.title')}</h1>
						<div className="heading-help-banner heading-config hidden-sm">
							<HelpBanner
								title={this.props.t('common.needHelp')}
								text={this.props.t('common.helpText')}
								linkText={this.props.t('common.moreInfo')}
								linkHref="https://help.plain.ninja/es/collections/12644645-reglas"
							/>
						</div>
						<div className="heading-filters">
							<FormGroup
								className="form-group form-search mr-2"
								controlId="searchRule"
							>
								<FormControl
									type="text"
									placeholder={this.props.t('common.searchPlaceholder')}
									value={this.state.searchRule}
									onChange={this.handleChangeSearch}
								/>
								<FiSearch />
							</FormGroup>
						</div>
						<div className="heading-actions">
							{(() => {
								const hasCreateRulesSubscription = hasSubscriptionFeature('CREATE_RULES');
								
								return (
									<button
										type="button"
										title={this.props.t('rules.createRule')}
										onClick={(e) => {
											e.preventDefault();
											if (hasCreateRulesSubscription) {
												this.openNewRuleModal();
											} else {
												this.setState({
													showUpgradeModal: true,
													upgradeFeature: this.props.t('rules.createRule')
												});
											}
										}}
										className={`btn btn-new ${!hasCreateRulesSubscription ? 'disabled-subscription' : ''}`}
										style={{
											opacity: !hasCreateRulesSubscription ? 0.5 : 1,
											cursor: !hasCreateRulesSubscription ? 'not-allowed' : 'pointer',
											position: 'relative'
										}}
									>
										<FiPlus />
									</button>
								);
							})()}
						</div>
					</div>

					{this.getContent()}
				</Layout>

				<Modal hideModal={this.props.hideModal} />

				{/* Modal de upgrade para funcionalidades bloqueadas */}
				<UpgradeModal
					show={this.state.showUpgradeModal}
					onClose={() => this.setState({ showUpgradeModal: false })}
					feature={this.state.upgradeFeature}
					requiredPlan="Pro"
				/>
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.rulesReducer,
		...reducers.timesReducer,
		...reducers.shiftsReducer,
		loading: reducers.rulesReducer.loading,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getAllRules: (q) => dispatch(rulesActions.getAllRules(q)),
	getSelectableAccounts: () => dispatch(rulesActions.getSelectableAccounts()),
	getSelectableTimeTypes: () => dispatch(timesActions.getSelectableTimeTypes()),
	getSelectableShifts: () => dispatch(shiftsActions.getSelectableShifts()),
	getRuleTypes: () => dispatch(rulesActions.getRuleTypes()),
	getAccountTypes: () => dispatch(rulesActions.getAccountTypes()),
	getContracts: (options) => dispatch(rulesActions.getContracts(options)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Rules));
